module.exports = __webpack_public_path__ + "static/media/harbiny.9b182e6d.png";